module.exports = __webpack_public_path__ + "img/28.b2ceef75.png";